import utils from './utils';
import Image from '../components/common/VectorImage';

/**
 * Renders nav icon from CDN
 * @param {string} imageName - Image Name to be fetched from CDN
 * @param {string} whiteLabelClient - Identifies white label client associated with the current user. Used to select partner-specific image.
 * @returns {JSX.Element}
 */
export const renderNavIcon = (imageName: string, whiteLabelClient: string) => {
  const imagePath = getPathForNavIcon(imageName, whiteLabelClient);
  return (
    <Image
      alt={imageName}
      url={imagePath}
      classes="h-8 w-8 align-middle"
      key={imagePath}
      data-testid={`nav-bar-${imageName}`}
    />
  );
};

/**
 * Returns CDN path for menu icon which matches it's path in the CDN repo
 * @param {string} imageName image name to be fetched from CDN
 * @param {string} whiteLabelClient - Identifies white label client associated with the current user. Used to select partner-specific image.
 * @return {string} CDN path for icon
 */
export const getPathForNavIcon = (imageName: string, whiteLabelClient: string) => {
  // If imageName contains a path separator, use it directly under dsp-northstar
  const basePath = imageName.includes('/')
    ? `/dsp-northstar/${imageName}`
    : `/dsp-northstar/feature-icons/${imageName}`;
  return utils.getCdnImagesPath(basePath, whiteLabelClient);
};

/**
 * Appends a nav entry-point `inid` to a menu item's path, respecting any query string the
 * path may already carry (e.g. `/foo?bar=1` -> `/foo?bar=1&inid=...`). Returns `path`
 * unchanged when `inid` is not provided.
 */
export const appendMenuInid = (path: string, inid?: string): string => {
  if (!inid) {
    return path;
  }
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}inid=${inid}`;
};
